const OVERVIEW_TEXT_FIELDS = [
  "elevator_pitch",
  "full_company_description",
  "mission_and_vision",
  "key_products_services",
  "unique_selling_points",
  "employee_perks",
  "achievements_awards",
];

const normalizeOverviewText = (value = "") =>
  String(value ?? "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .trim();

const getOverviewFieldValue = (entity = {}, field = "") => {
  if (!entity || typeof entity !== "object") return "";
  if (field === "full_company_description") {
    return normalizeOverviewText(
      entity?.full_company_description || entity?.company_description || ""
    );
  }
  return normalizeOverviewText(entity?.[field]);
};

export function isCompanyProfileOverviewComplete(entity = {}) {
  return OVERVIEW_TEXT_FIELDS.every((field) => Boolean(getOverviewFieldValue(entity, field)));
}

export function isCompanyProfileOverviewIncomplete(entity = {}) {
  return !isCompanyProfileOverviewComplete(entity);
}
